import { CreditCard } from "./CreditCard";

interface CreditGridProps {
  transactions: any[];
  isLoading: boolean;
  paymentAmounts: Record<string, string>;
  onPaymentAmountChange: (id: string, value: string) => void;
  onPayment: (id: string, remainingAmount: number) => void;
}

export const CreditGrid = ({
  transactions,
  isLoading,
  paymentAmounts,
  onPaymentAmountChange,
  onPayment,
}: CreditGridProps) => {
  if (isLoading) {
    return <div className="text-center p-4">Chargement...</div>;
  }

  if (!transactions || transactions.length === 0) {
    return <div className="text-center p-4 text-gray-500">Aucun crédit en cours</div>;
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {transactions.map((transaction: any) => (
        <CreditCard
          key={transaction.id}
          transaction={transaction}
          paymentAmount={paymentAmounts[transaction.id] || ""}
          onPaymentAmountChange={(value) => onPaymentAmountChange(transaction.id, value)}
          onPayment={() => onPayment(transaction.id, transaction.remaining_amount)}
        />
      ))}
    </div>
  );
};